import React from 'react';
import { connect } from 'react-redux';

import {
  Col,
  Row,
  Checkbox,
  message,
  Input
} from 'antd';

import HoldingListController from './holding-list-controller';

import {
  _getMyHoldingList, _getCartByReference,
  _postDuplicateCartToHoldingList
} from '../../../services';

import './modal.css';

class HoldingList extends React.Component {

  render() {

    return (
      <div key="holding-list-selector" className="holding-list-body">
        <div id="style-3">

          <Row gutter={8}>
            <h3
              style={{marginLeft:10}}
            >Holding Lists:</h3>
          </Row>

          {this.state.holdingLists.map((hl, index) => (
            <Row key={index} style={{ marginBottom: 16 }}>
              <Col span={22}>

                <HoldingListController 
                  enterpriseId={this.props.quotation.enterprise._id}
                  updateHoldingListProduct={this.updateHoldingListProduct}
                  selectedListId={ this.state.selectedListId }
                  activeKeys={this.state.activeKeys}
                  handleOnDeleteHoldingList={ this.handleOnDeleteHoldingList }
                  handleOnToggleCollapse={ this.handleOnToggleCollapse }
                  holdingList={hl}/>
                
              </Col>

              <Col span={2} align="middle">
                <Checkbox
                  onChange={ () => this.handleOnSelectHoldingList( hl._id ) }
                  checked={ hl._id === this.state.selectedListId }
                  key={ hl._id }
                />
              </Col>

            </Row>
          ))}

          <Row>
            <Input.Search
              style={{width: 400}}
              placeholder="Ref Number"
              enterButton="Create holding list"
              onSearch={this.handleCreateHoldingListFromRefNumber}
            />
          </Row>

        </div>
      </div>
    )

  }

  handleCreateHoldingListFromRefNumber = (refNumber) => {

    _getCartByReference(refNumber)
    .then( res => {

      const { cartId } = res.data

      if( !cartId ){
        return message.error("No cart found!")
      }

      _postDuplicateCartToHoldingList({cartId})
      .then( holdingListRes => {

        const { holdingList } = holdingListRes.data

        this.setState({
          holdingLists: [...this.state.holdingLists, holdingList],
          selectedList: holdingList,
          selectedListId: holdingList._id
        })

        this.props.handleOnSelectHoldingList(holdingList)

      })

    })

  }

  // renderFreeDeliveryTag = ( productOrder ) => {

  //   if( productOrder.product.movFreeDelivery ){
      
  //     let totalPrice = this.getTotalPrice(productOrder);

  //     if( (totalPrice * productOrder.quantity) > productOrder.product.movFreeDelivery ){
  //       return (
  //         <Tag 
  //           style={{ marginLeft: 8 }} 
  //           color="green">Free Delivery</Tag>
  //       );
  //     } else {
  //       return (
  //         <Tag 
  //           style={{ marginLeft: 8 }}
  //           color="orange">Free Delivery > {productOrder.product.movFreeDelivery}
  //         </Tag>
  //       )
  //     }

  //   }

  //   return null;
  // }

  // renderItemName = ( product ) => {

  //   return (
  //     <div>
  //       {product.product.title}
  //       {this.renderFreeDeliveryTag(product)}
  //       {/* {
  //         product.product.movFreeDelivery? 
  //         (
  //           <Tag style={{ marginLeft: 8 }} colour="green">Free Delivery > {product.product.movFreeDelivery}</Tag>
  //         ): 
  //         ""
  //       } */}
  //     </div>
  //   )
    
  // }

  // renderVariantName = ( variants ) => {

  //   if( !variants ){
  //     return null;
  //   }

  //   const variantKeys = Object.keys(variants);

  //   return (
  //     <Row style={{ fontSize: 12, color: "#595959"}}>
  //       {variantKeys.map(
  //         key => (
  //           <div key={key} style={{ paddingRight: 8 }}>
  //             {key}: {variants[key].name}
  //           </div>
  //         )
  //       )}
  //     </Row>
  //   );
  // }
  
  // renderPrice = ( productOrder, productIndex, holdingListId ) => {
    
  //   let variantKeys = [];
    
  //   if( productOrder.variants ){
  //     variantKeys = Object.keys(productOrder.variants);
  //   }
    
  //   let bulkDiscount = [];

  //   let totalPrice = this.getTotalPrice( productOrder );

  //   const BulkDiscountButton = ({ discount, productDiscount }) => (
  //     <Button 
  //       type={ productDiscount === discount && productOrder.quantity > 1? "primary": "" }
  //       onClick={() => this.onSetBulkDiscount({
  //         discount, 
  //         productIndex, 
  //         holdingListId
  //       })} 
  //       size="small">- {discount}%</Button>
  //   );

  //   let productBulkDiscount = productOrder.product.bulkDiscount.sort(
  //     ( a, b ) => {
  //       return a.quantity > b.quantity
  //     }
  //   );

  //   if( productBulkDiscount.length > 0 && productOrder.quantity >= productBulkDiscount[0].quantity ){

  //     // if( productOrder.quantity >= productBulkDiscount[0].quantity ){

  //     let discountTier = productBulkDiscount.reduce(
  //       ( acc, cur ) => {

  //         if ( productOrder.quantity >= cur.quantity ) {
  //           return cur;
  //         }

  //         return acc;
  //       }, {}
  //     )

  //     bulkDiscount = (
  //       <Col>
  //         Bulk Discount {discountTier.quoteAndForgetCustomBulkDiscount}% Applied
  //       </Col>
  //     )
  //       // render product 
  //     // }

  //     // if( productOrder.quantity <= productBulkDiscount[0].quantity ){

  //       // bulkDiscount = [
  //       //   <Col>
  //       //     <BulkDiscountButton discount={0} />
  //       //   </Col>,
  //       //   <Col>
  //       //     <BulkDiscountButton discount={3} />
  //       //   </Col>,
  //       //   <Col>
  //       //     <BulkDiscountButton discount={5} />
  //       //   </Col>,
  //       //   <Col>
  //       //     <BulkDiscountButton discount={7} />
  //       //   </Col>,
  //       //   <Col>
  //       //     <BulkDiscountButton discount={10} />
  //       //   </Col>
  //       // ]
  //     //   // render product 
  //     // } else {

  //     //   let discountTier = productBulkDiscount.reduce(
  //     //     ( acc, cur ) => {

  //     //       if ( productOrder.quantity >= cur.quantity ) {
  //     //         return cur;
  //     //       }

  //     //       return acc;
  //     //     }, {}
  //     //   )

  //     //   bulkDiscount = (
  //     //     <Col>
  //     //       Bulk Discount {discountTier.quoteAndForgetCustomBulkDiscount}% Applied
  //     //     </Col>
  //     //   )
  //     // }
  //   } else {
  //     bulkDiscount = [
  //       <Col>
  //         <BulkDiscountButton productDiscount={productOrder.quoteAndForgetCustomBulkDiscount} discount={0} />
  //       </Col>,
  //       <Col>
  //         <BulkDiscountButton productDiscount={productOrder.quoteAndForgetCustomBulkDiscount} discount={3} />
  //       </Col>,
  //       <Col>
  //         <BulkDiscountButton productDiscount={productOrder.quoteAndForgetCustomBulkDiscount} discount={5} />
  //       </Col>,
  //       <Col>
  //         <BulkDiscountButton productDiscount={productOrder.quoteAndForgetCustomBulkDiscount} discount={7} />
  //       </Col>,
  //       <Col>
  //         <BulkDiscountButton productDiscount={productOrder.quoteAndForgetCustomBulkDiscount} discount={10} />
  //       </Col>
  //     ]
  //   }

  //   return (
  //     <Row type="flex" align="middle" gutter={8}>

  //       <Col>
  //         ${totalPrice}
  //         {/* {productOrder.product.price.po} */}
  //       </Col>
  //       {/* {variantKeys.map(
  //         key => (
  //           <Col key={key}>
  //             + {productOrder.variants[key].price.po}
  //           </Col>
  //         )
  //       )} */}
  //       {bulkDiscount}
  //     </Row>  
  //   )
  // }
  
  constructor( props ){
    super(props);
    
    this.state = {

      holdingLists: [],
      selectedList: {},
      activeKeys: {},
      generatedCheckboxes: [{ checked: false }],
      selectedListId: props.selectedListId || ""
    
    }
    // this._dbnceUpdateHoldingListQuantity = debounce( this._dbnceUpdateHoldingListQuantity, 300 );

  }

  componentDidMount(){
    _getMyHoldingList()
      .then(res => {
        // console.log(res.data.holdingList)
        this.setState({ holdingLists: res.data.holdingList.reverse() })
        
      })
      .catch(err => {
        // alert(JSON.stringify(err.response)  )
      })

  }

  handleOnDeleteHoldingList = ( holdingListId ) => {
    this.setState({
      holdingLists: this.state.holdingLists.filter( ( _holdingList, index ) => {

        return _holdingList._id !== holdingListId;
        
      })
    })
  }

  handleOnSelectHoldingList = ( selectedListId ) => {

    const holdingList = this.state.holdingLists.reduce(
      ( acc, cur ) => {

        if( cur._id === selectedListId ){
          return cur;
        }

        return acc;
      }, { products: [] }
    );

    // console.log(holdingList)

    if( holdingList.products.length === 0 ){
      return message.error('Can\'t select a holding list with 0 products.');
    }

    this.setState({
      selectedListId,
    });

    this.props.handleOnSelectHoldingList( holdingList );
  
  }

  updateHoldingListProduct = (holdingListId, products ) =>{
    
    this.setState({
      holdingLists: this.state.holdingLists.map( holdingList => {

        if( holdingList._id !== holdingListId ){
          return holdingList;
        }

        return {
          ...holdingList,
          products
        }

      })
    })


  }

  // onSetBulkDiscount = ({ discount, productIndex, holdingListId }) => {
  //   _postSetCustomBulkDiscount({
  //     discount, 
  //     productIndex, 
  //     holdingListId
  //   })
  //     .then( res => {
  //       // this.props.setHoldingListBulkDiscount({
  //       //   discount, 
  //       //   productIndex, 
  //       //   holdingListId
  //       // })

  //       this.props.setHoldingListProduct({
  //         product: res.data.product,
  //         productIndex,
  //         holdingListId
  //       });

  //     })
  //     .catch( e => {
  //       console.log( e.response.data )
  //       message.error( e.response.data.msg )
  //     })
  // }
  
  /**
   * 
   * @todo handle response
   * 
   */
  // _dbnceUpdateHoldingListQuantity = ({ holdingListId, productIndex, quantity }) => {
  //   _postUpdateHoldingListQuantity({ holdingListId, productIndex, quantity })
  //     .then( res => {
  //       message.destroy();
  //       message.success(`${res.data.product.product.title} -> ${quantity}`);

  //       this.props.setHoldingListProduct({
  //         product: res.data.product,
  //         productIndex,
  //         holdingListId
  //       });

  //     });
  // }

  // getTotalPrice = ( productOrder ) => {
  //   return productOrder.totalAmount.price;
  // }

  // handleChangeSerialNumber = (holdingListId, newSerialNumber, productIndex) => {

  //   this.props.updateHoldingListProductSerialNumber({
  //     serialNumber: newSerialNumber,
  //     holdingListId,
  //     productIndex
  //   })

  // }

  /**
   * @todo handle response 
   */
  // handleDeleteHoldingList = ( holdingListId ) => {
  //   // let _id = this.props.createdLists[index]._id;
  //   _deleteHoldingList( holdingListId )
  //     .then(res => {

  //       this.props.updateHoldingLists(
  //         this.props.holdingList.filter(
  //           hl => {

  //             if( hl._id === holdingListId ){
  //               message.success(`Deleted ${hl.name}`);
  //             }

  //             return hl._id !== holdingListId;
  //           }
  //         )
  //       );
  //     }).catch(err => {
  //       // alert( JSON.stringify(err.response) );
  //     });
  // }
  // handleOnDeleteHoldingList = ( holdingListId ) => {
  //   this.props.updateHoldingList
  // }

  // handleDeleteProduct = (holdingListId, productIndex) => {
 
  //   const { holdingList } = this.props;

  //   let product = holdingList.reduce(
  //     ( acc, cur ) => {
  //       if( cur._id === holdingListId ){
  //         return cur.products[productIndex];
  //       }

  //       return acc;
  //     }, {}
  //   );

  //   let loadingMsg = message.loading(`Deleting ${product.product.title}`, 0);

  //   setTimeout( () => {
  //     _deleteHoldingListProduct({
  //       holdingListId,
  //       productIndex
  //     })
  //       .then( res => {
  
  //         loadingMsg();
  
  //         this.props.deleteHoldingListProduct({
  //           holdingListId,
  //           productIndex
  //         });

  //       })
  //   }, 300 );

  // }

  // onQuantityChange = ({
  //   holdingListId,
  //   productIndex,
  //   quantity
  // }) => {

  //   let actualValue;

  //   if ( quantity === null) {
  //     actualValue = 1;
  //   } else {
  //     actualValue = quantity;
  //   }
    
  //   // _postUpdateHoldingListQuantity
    
  //   this.props.updateHoldingListProductQuantity({
  //     quantity: actualValue,
  //     holdingListId,
  //     productIndex
  //   })
    
  //   this._dbnceUpdateHoldingListQuantity({
  //     quantity: actualValue,
  //     holdingListId,
  //     productIndex
  //   });

  // }

  
  handleOnToggleCollapse = ( keys ) => {

    this.setState({ activeKeys: [ ...keys ]})

  }

  // handleReorderHoldingList = (holdingListId) => {
   

  //   let holdingListProductsSerialNumber = this.props.holdingList.filter( hl => hl._id === holdingListId )[0].products.reduce(
  //     ( acc, cur ) => {

  //       acc.push( cur.serialNumber );

  //       return acc;
  //     }, []
  //   );

  //   _postUpdateHoldingListSerialNumber({
  //     holdingListId,
  //     holdingListProductsSerialNumber
  //   })
  //     .then( res => {
  //       this.props.updateHoldingLists(res.data.holdingList);
        
  //     })

  // }

}

export default connect(
	state => ({
		quotation: state.quotation
	}),

	dispatchEvent => ({
    // setHoldingListProduct: ( product, productIndex ) => dispatchEvent( setHoldingListProduct( product, productIndex ) )
		// setQuotationActiveBilling: ( address ) => dispatchEvent( setQuotationActiveBilling(address) ),
		// setQuotationActiveShipping: ( address ) => dispatchEvent( setQuotationActiveShipping(address) ),
		// setQuotationUser: ( user ) => dispatchEvent( setQuotationUser( user ) ),
		// setQuotationUserNewAddress: ( address ) => dispatchEvent( setQuotationUserNewAddress( address) )
	})
)(HoldingList);


// WEBPACK FOOTER //
// ./src/components/quotation/add-quotation-modal/holding-list-selector.js